import { Component, OnInit } from '@angular/core';
import { ImportInoKupciDobavljaciDto, PravnaLicaClient } from '@kodit/core/data-api';
import { AlertService } from '@kodit/core/services';
import { FileUploadService } from '@kodit/core/shared-ui';
import { LoaderService } from 'libs/core/shared-ui/src/lib/loader/loader.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'kodit-kupci-i-dobavljaci-inostrani-import',
  templateUrl: './kupci-i-dobavljaci-inostrani-import.component.html',
  styleUrls: ['./kupci-i-dobavljaci-inostrani-import.component.scss'],
})
export class KupciIDobavljaciInostraniImportComponent implements OnInit {
  /** Subs */
  private _uploadSub: Subscription = new Subscription();
  private _errorSub: Subscription = new Subscription();

  /** Props */
  uploadCompleted: boolean;

  readonly MAX_FILE_SIZE: number = 10000000;

  constructor(
    private _client: PravnaLicaClient,
    private _alertService: AlertService,
    private _loaderService: LoaderService,
    private _uploadService: FileUploadService
  ) {}

  ngOnInit(): void {
    this._uploadService.setMaxAttachmentSize = this.MAX_FILE_SIZE;
  }

  onUpload(file: File) {
    this._loaderService.setLoadingText =
      'Molimo sačekajte';
    this._loaderService.setShowLoader = true;
    this.uploadCompleted = false;
    this._uploadSub = this._client
      .importInostrana({
        data: file,
        fileName: '',
      })
      .subscribe(
        async (res) => {
          this.uploadCompleted = true;
          if(res.data.length != 0){
                this.exportToExcel(res.data);
                this._alertService.addWarnMsg("Na Vašem računaru preuzet je novi Excel file sa početnim stanjima čije podatke niste ispravno uneli. Ispravite ih i ponovo otpremite file.");
                await new Promise(resolve => setTimeout(resolve, 3000));

              }else{
                this._alertService.addSuccessMsg("Uspešno su uneta početna stanja.");
                await new Promise(resolve => setTimeout(resolve, 2000));
                location.reload();
              }
        },
        (error) => {
          this.uploadCompleted = true;
          this._loaderService.reset();
        },
        () => {
          this._loaderService.reset();
        }
      );
  }

  downloadTemplate() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      '/assets/podesavanje/import_files/inostrani_kupci_i_dobavljaci_sablon.xls.xlsx'
    );
    link.setAttribute('download', 'inostrani_kupci_i_dobavljaci_sablon.xls.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  exportToExcel = (roba: ImportInoKupciDobavljaciDto[]) => {
    const workbook = XLSX.utils.book_new();
    const columns = [
      { field: 'registracioniBroj', header: 'Registracioni broj' },
      { field: 'naziv', header: 'Naziv' },
      { field: 'grad', header: 'Grad' },
      { field: 'drzava', header: 'Država' },
      { field: 'potrazivanje', header: 'Kupac' },
      { field: 'dugovanje', header: 'Dobavljač' },
      { field: 'greska', header: 'Greška' }
    ];

    const worksheet1 = XLSX.utils.aoa_to_sheet([
      columns.map(col => col.header),
      ...roba.map((row: { [x: string]: any; }) =>
        columns.map(col => row[col.field] || '')
      )
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet1, 'neispravni_podaci');
    XLSX.writeFile(workbook, `neispravni-podaci.xlsx`);
  };

  ngOnDestroy(): void {
    this._uploadSub.unsubscribe();
    this._errorSub.unsubscribe();
  }
}
